import { makeStyles } from "@material-ui/core";
import { white, blueLink, whiteGrey, green } from "../../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  tipsSection: {
    boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.04)",
    borderRadius: "30px",
    overflow: "hidden",
    [down("sm")]: {
      background: whiteGrey,
    },
  },
  tipsSectionMain: {
    background: white,
    padding: "20px 30px",
    [down("sm")]: {
      background: whiteGrey,
    },
  },
  tipsSectionSecondary: {
    background: "#838D95",
    padding: "25px 30px",
  },
  tipBox: {
    padding: "10px 15px",
    background: "rgb(74 148 236 / 10%)",
    borderRadius: "10px",
    margin: "7.5px",
    cursor: "pointer",
    "& p": {
      color: blueLink,
    },
  },
  active: {
    background: green,
    "& p": {
      color: white,
    },
  },
  counterInput: {
    border: `1px solid ${whiteGrey}`,
    borderRadius: "10px",
    position: "relative",
    height: "53px",
    "&:before": {
      content: "'$'",
      position: "absolute",
      display: "block",
      width: "25px",
      transform: "translate(10px, -50%)",
      top: "50%",
    },
    "& input, input:focus": {
      border: "none",
      outline: "none",
      textAlign: "center",
      fontFamily: "sbcBold",
      fontSize: "16px",
      width: "100px",
    },
  },
  counter: {
    "& input": {},
  },
  counterBtn: {
    background: "rgb(74 148 236 / 10%)",
    height: "45px",
    width: "45px",
    borderRadius: "100px",
    margin: "0 20px",
    cursor: "pointer",
  },
}));

export default useStyles;
